module.exports = __webpack_public_path__ + "media/dashboard/assets/images/ice-breaker-4b02302acddc102df6d5d7e7644eaa36.png";